export const roles = {
    "ADMINISTRATOR": "Администратор",
    "WRITE": "Редактор",
    "READ": "Чтение",
    "PERFORMER": "Исполнитель",
    "PERFORMER_TEMP": "Ограниченный Исполнитель"
}

export const rolesOptions = [
    {
        label: "Администратор",
        value: "ADMINISTRATOR"
    },
    {
        label: "Редактор",
        value: "WRITE"
    },
    {
        label: "Чтение",
        value: "READ"
    },
    {
        label: "Исполнитель",
        value: "PERFORMER"
    },
    {
        label: "Ограниченный Исполнитель",
        value: "PERFORMER_TEMP"
    }
]